import { Card } from './cards/featured';

export function UnitsFeatured({ units, style, amenities }) {
    if(units.length == 0) return null;

    return(
        <div>
            <h2 className="rentals-section__headline">Best Match</h2>
            <p>The following are the closest matches from our current availability based on your search criteria. </p>
            <div className="rentals-section__list rentals-section__list--horizontal">
                {units.map(unit => (
                    <Card unit={ unit } amenities={ amenities } key={unit.apartmentId} />
                ))}
            </div>
        </div>
    );
}